import React, { useEffect, Fragment, useState } from 'react'
import DataLoader from '../../../Utils/DataLoader';
import BannerSec from '../restaurent/bannerSec/BannerSec';
import { Link } from 'react-router-dom';
import { apiData } from '../../../actions';
import { UsePlaceAuth } from '../../../AppContext/AppContext';
import { Helmet } from 'react-helmet';
import { _Deals_ } from '../../../Redux/Action/Action';
import { useDispatch, useSelector } from 'react-redux';


const FlightDeals = () => {
    const [dealsData, setDealsData] = useState([]);
    const [loader, setLoader] = useState(false);
    const { dealsTabActive, setDealsTabActive } = UsePlaceAuth();
    const place = useSelector(state => state.place);
    // const { active, setActive } = UsePlaceAuth()
    const dispatch = useDispatch();
    const GetDeals = async () => {
        setLoader(true)
        let payload = {
            city: place,
            keyword: "Flights",
            limit: 12
        };
        let apiRes = await apiData.getRandomDeals(payload);
        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setDealsData(
                apiRes?.data?.data
            );
            setLoader(false);
        }
        if (apiRes?.status >= 400 && apiRes?.status <= 500) {
            console.log("error");
        }
    };
    useEffect(() => {
        let script = document.createElement('script');
        setLoader(true)
        script.src = "https://tp.media/content?trs=26480&shmarker=130544&locale=en&currency=usd&show_hotels=false&powered_by=false&border_radius=0&plain&color_focused=%23196AE1&=true&color_button=%23196AE1&color_button_text=%23196AE1&promo_id=3414&campaign_id=111"
        document.getElementById("flightDeal").appendChild(script)
        setLoader(false)
    }, []);

    useEffect(() => {
        dispatch(_Deals_())
        GetDeals();
        setDealsTabActive("flights")
    }, [place]);

    return (

        <div>
            <Fragment>
                <Helmet>
                    <title>Find Exclusive Deals for your destination - MySittiVacations</title>
                    <meta name="description" content="Looking for the best travel deals? Find exclusive offers for your destination with our expert guide. Discover amazing discounts on flights, hotels, and activities to help you save big on your next trip."></meta>
                </Helmet>
                <BannerSec />
                <div
                    className="itemBox"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                >
                    <div className="offer-section">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                                    <div className="header-sec">
                                        <h2>Offers for you</h2>
                                        <ul>
                                            <li className={dealsTabActive === "All" ? "activeMenu" : ""}>
                                                <Link to={`/deals/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("All")} >
                                                    <img src={
                                                        dealsTabActive === "All"
                                                            ? "/images/allinclusicActive-icon.png"
                                                            : "/images/allinclusic-icon.png"
                                                    } alt="allinclusic-icon" />
                                                    All Inclusive
                                                </Link>
                                            </li>


                                            <li className={dealsTabActive === "flights" ? "activeMenu" : ""}>
                                                <Link to={`/deals/flights/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("flights")} >
                                                    <img src={
                                                        dealsTabActive === "flights"
                                                            ? "/images/flightActive-icon.png"
                                                            : "/images/flight-icon.png"
                                                    } alt="flight-icon" />
                                                    Flights
                                                </Link>
                                            </li>
                                            <li className={dealsTabActive === "hotels" ? "activeMenu" : ""}>
                                                <Link to={`/deals/hotels/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("hotels")} >

                                                    <img src={
                                                        dealsTabActive === "hotels"
                                                            ? "/images/hotelActive-icon.png"
                                                            : "/images/hotel-icon.png"
                                                    } alt="hotel-icon" />
                                                    Hotels
                                                </Link>
                                            </li>
                                            <li className={dealsTabActive === "vacations" ? "activeMenu" : ""}>
                                                <Link to={`/deals/vacations/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("vacations")}>

                                                    <img src={
                                                        dealsTabActive === "vacations"
                                                            ? "/images/vacationActive-icon.png"
                                                            : "/images/vacation-icon.png"
                                                    } alt="vacation-icon" />
                                                    Vacations
                                                </Link>
                                            </li>
                                            <li className={dealsTabActive === "tours" ? "activeMenu" : ""}>
                                                <Link to={`/deals/tours/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("tours")}>

                                                    <img src={
                                                        dealsTabActive === "tours"
                                                            ? "/images/tourActive-icon.png"
                                                            : "/images/tour-icon.png"
                                                    } alt="tour-icon" />
                                                    Tours
                                                </Link>
                                            </li>
                                            <li className={dealsTabActive === "cruises" ? "activeMenu" : ""}>
                                                <Link to={`/deals/cruises/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("cruises")}>

                                                    <img src={
                                                        dealsTabActive === "cruises"
                                                            ? "/images/curizeActive-icon.png"
                                                            : "/images/curize-icon.png"
                                                    } alt="curize-icon" />
                                                    Cruises
                                                </Link>
                                            </li>
                                            <li className={dealsTabActive === "adventures" ? "activeMenu" : ""}>
                                                <Link to={`/deals/adventures/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("adventures")}>

                                                    <img src={
                                                        dealsTabActive === "adventures"
                                                            ? "/images/advantureActive-icon.png"
                                                            : "/images/advanture-icon.png"
                                                    } alt="advanture-icon" />
                                                    Adventures
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div id="flightDeal">
                                </div>
                                {
                                    !loader ? <div className="deal-flight">
                                        <div className="container">
                                            <div className="row">
                                                {
                                                    dealsData && dealsData?.map((ele) => {
                                                        return (
                                                            <div className="col-lg-3 col-12">
                                                                <a href={ele?.link} target="_blank" rel="noreferrer">
                                                                    <div data-aos="zoom-in-right" className="discount-block blog">
                                                                        <img loading="lazy" src={`${ele?.image}`} alt='Flight-deals' />
                                                                        <h5>{ele?.city_name} <i className="fa fa-plane flight_deal_icon" aria-hidden="true"></i> {place}</h5>
                                                                    </div> </a>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                        :
                                        <div style={{ marginTop: "60vh" }}>
                                            <DataLoader />
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        </div>
    )
}

export default FlightDeals